import logo from "./Components/Assets/logo.png";

const whatsapp = "5575999645557";
const whatsappBot = "5575999645557";


const formatarTelefone = (numero) => {
    const semCodigo = numero.startsWith("55") ? numero.slice(2) : numero;
    const ddd = semCodigo.slice(0, 2);
    const parte1 = semCodigo.slice(2, 3);
    const parte2 = semCodigo.slice(3, 7);
    const parte3 = semCodigo.slice(7);
    return `(${ddd}) ${parte1} ${parte2}-${parte3}`;
};

const clinicaConfig = {
    REACT_APP_API_BASE_URL: "https://clinic-12wd.onrender.com",
    nomeClinica: "Samec De Canudos",
    whatsapp,
    whatsappFormatado: formatarTelefone(whatsapp),
    whatsappBot: (whatsappBot),
    email: "samecdecanudos@gmail.com",

    avenida: "Santo Antônio",
    rua: "Av. Santo Antônio",
    bairro: "Canudos",
    numeroCasa: "232-322",
    cidade: "Canudos",
    estado: "Bahia",
    uf: "BA",
    cep: "48520-000",
    googleMapsLink: "https://maps.app.goo.gl/jMDaubD2NGIv8iCTP",
    EnderecoCompleto() {
        const linha1 = this.avenida === ""
            ? `Rua: ${this.rua}, ${this.numeroCasa} - ${this.bairro}`
            : `Av: ${this.avenida}, ${this.numeroCasa}`;
        const linha2 = this.bairro === this.cidade 
            ? `${this.cidade} - ${this.uf}, ${this.cep}`
            : `${this.bairro}, ${this.cidade} - ${this.uf}, ${this.cep}`;

        return (
            <>
                {linha1}
                <br />
                {linha2}
            </>
        );
    },
    mapaUrl() {
        const endereco = `${this.rua || this.avenida} ${this.numeroCasa}, ${this.bairro}, ${this.cidade} - ${this.uf}, ${this.cep}`;
        return `https://www.google.com/maps?q=${encodeURIComponent(endereco)}&output=embed`;
    },

    instagram: "sameccanudos",
    facebook: "sameccanudos",
    linkedin: "",

    logo,

    diaDefuncionamento: "Segunda á sexta",
    HoraDefuncionamento: "06:00-12:00, 14:00-17:00",

    descricao() {
        return `A ${this.nomeClinica} nasceu com a missão de levar saúde, confiança e bem-estar a cada paciente. Atuando há mais de uma década em ${this.cidade} e região, oferecemos exames laboratoriais e consultas médicas com alto padrão de qualidade. Aliamos tecnologia moderna, resultados precisos e um atendimento próximo e humano, porque cuidar da saúde é cuidar de quem você ama.`;
    }

    /*Solicitar images ( da clinica, da equipe) para dicionar no about*/
    /*pedir images e relatos de pacientes frequentes, para adicionar no about*/

};

const localDescription = clinicaConfig.descricao.bind(clinicaConfig);
clinicaConfig.descricao = function descricao() {
    return this._remoteDescription || localDescription();
};

export async function loadClinicConfig() {
    try {
        const domain = window.location.hostname;
        const response = await fetch(`${clinicaConfig.REACT_APP_API_BASE_URL}/public/clinic-info`, {
            headers: { 'X-Client-Domain': domain }
        });
        if (!response.ok) return clinicaConfig;
        const data = await response.json();
        const clinic = data.clinic;
        if (!clinic) return clinicaConfig;
        const address = clinic.address || {};
        const social = clinic.social || {};
        const hours = clinic.businessHours || {};
        const contact = clinic.whatsapp || clinicaConfig.whatsapp;
        Object.assign(clinicaConfig, {
            nomeClinica: clinic.name || clinicaConfig.nomeClinica,
            whatsapp: contact,
            whatsappFormatado: formatarTelefone(contact),
            email: clinic.email || clinicaConfig.email,
            avenida: address.avenue || clinicaConfig.avenida, rua: address.street || clinicaConfig.rua, bairro: address.neighborhood || clinicaConfig.bairro,
            numeroCasa: address.number || clinicaConfig.numeroCasa, cidade: address.city || clinicaConfig.cidade, estado: address.state || clinicaConfig.estado, uf: address.uf || clinicaConfig.uf, cep: address.postalCode || clinicaConfig.cep,
            googleMapsLink: address.googleMapsLink || clinicaConfig.googleMapsLink, instagram: social.instagram || clinicaConfig.instagram, facebook: social.facebook || clinicaConfig.facebook, linkedin: social.linkedin || clinicaConfig.linkedin,
            diaDefuncionamento: hours.daysLabel || clinicaConfig.diaDefuncionamento, HoraDefuncionamento: hours.hoursLabel || clinicaConfig.HoraDefuncionamento,
            logo: clinic.logoUrl || clinicaConfig.logo, _remoteDescription: clinic.description || ''
        });
    } catch (error) {
        console.warn('Usando configuracao local da clinica.');
    }
    return clinicaConfig;
}

export default clinicaConfig;
